// extracted by mini-css-extract-plugin
export default {"spinner":"ThankYou_spinner__guTVM","spinner-d3wgkg":"ThankYou_spinner-d3wgkg__UnYIJ"};